import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import {
  NotePaymentCreate,
  NotePaymentCreateVariables,
} from 'common/graphql/__generated__/NotePaymentCreate';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import NOTE_PAYMENT_CREATE from 'common/graphql/NotePaymentCreate.graphql';

type PaymentTrackingNotesSectionProps = Pick<
  NotesSectionProps,
  'listRefreshRequest'
> & {
  paymentTrackingId: string;
  data: NotesEntityFields[];
  loading?: boolean;
  isViewOnly?: boolean;
};

export const PaymentTrackingNotesSection: React.FC<
  PaymentTrackingNotesSectionProps
> = ({ paymentTrackingId, data, loading, listRefreshRequest, isViewOnly }) => {
  return (
    <GenericNotesSection<
      any,
      NotePaymentCreate, // TMutationResult
      NotePaymentCreateVariables // TMutationVariables
    >
      entityId={paymentTrackingId}
      data={data}
      loading={loading}
      mutationDocument={NOTE_PAYMENT_CREATE}
      listRefreshRequest={listRefreshRequest}
      isViewOnly={isViewOnly}
    />
  );
};
